interface HeroProps {
  backgroundImage: string
  title: string
  ctaLabel: string
  ctaUrl: string
  altText?: string
  subtitle?: string
}

export default function Hero({
  backgroundImage,
  title,
  ctaLabel,
  ctaUrl,
  altText = "",
  subtitle,
}: HeroProps) {
  return (
    <section className="relative h-screen w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={backgroundImage}
          alt={altText}
          width={1920}
          height={1080}
          loading="eager"
          fetchPriority="high"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-black/20" />

      <div className="relative z-10 h-full flex flex-col justify-center items-center text-center px-4">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4">
          {title}
        </h1>
        {subtitle && (
          <p className="text-base md:text-lg text-white/90 mb-8 max-w-2xl">
            {subtitle}
          </p>
        )}
        <a
          href={ctaUrl}
          className="inline-block bg-black text-white rounded-md px-8 py-3 text-sm font-normal font-unsf hover:bg-black transition-colors"
        >
          {ctaLabel}
        </a>
      </div>
    </section>
  )
}
